// extracted by mini-css-extract-plugin
module.exports = {"iframe-container":"IFrameContent_iframe-container__yUwuP","iframe":"IFrameContent_iframe__emIfB","fallback":"IFrameContent_fallback__U7Fdr"};